<template>
    <Layout :bg="!loading && client.profileSettings ? client.profileSettings.background : ''">
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>

        <div class="row my-3 social-media-wrapper" v-if="!loading && client.socialMedia">
            <div class="social-media-line">
                <div class="social-media" v-if="client.socialMedia.facebook">
                    <a :href="client.socialMedia.facebook" target="_blank"><i class="fab fa-facebook" style="color: #1877f2"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.twitter">
                    <a :href="client.socialMedia.twitter" target="_blank"><i class="fab fa-twitter" style="color: #1da1f2"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.youtube">
                    <a :href="client.socialMedia.youtube" target="_blank"><i class="fab fa-youtube" style="color: #ff0000"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.twitch">
                    <a :href="client.socialMedia.twitch" target="_blank"><i class="fab fa-twitch" style="color: #9146ff"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.instagram">
                    <a :href="client.socialMedia.instagram" target="_blank"><i class="fab fa-instagram" style="color: #c32aa3"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.linkedin">
                    <a :href="client.socialMedia.linkedin" target="_blank"><i class="fab fa-linkedin" style="color: #0a66c2"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.github">
                    <a :href="client.socialMedia.github" target="_blank"><i class="fab fa-github" style="color: #211F1F"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.snapchat">
                    <a href="" @click.prevent="() => $bvModal.show('modal-snapchat')"><i class="fab fa-snapchat" style="color: #fffc00"></i></a>
                </div>
                <div class="social-media" v-if="client.socialMedia.telegram">
                    <a :href="'https://t.me/' + client.socialMedia.telegram" target="_blank"><i class="fab fa-telegram" style="color: #0088cc"></i></a>
                </div>
            </div>
        </div>
        <div class="my-5" v-else></div>

        <b-modal
            v-if="!loading && client.socialMedia && client.socialMedia.snapchat"
            id="modal-snapchat"
            centered
            title="Snapchat"
            title-class="font-18"
            size="md"
            hide-footer
        >
            <div class="d-flex justify-content-center align-items-center flex-column">
                <img :src="'https://feelinsonice-hrd.appspot.com/web/deeplink/snapcode?username='+client.socialMedia.snapchat+'&type=PNG&size=240'">
                <h3 class="mt-2">{{ client.socialMedia.snapchat }}</h3>
            </div>
        </b-modal>

        <div class="row">
            <div class="col-xl-4">
                <div
                    class="card client-main have-function"
                    id="have-function"
                    :class="[client.socialMedia ? 'with-social-media' : '', !loading && client.profileSettings.admin ? 'with-ribbon' : '']"
                >
                    <div class="card-header" :class="client.status">
                        <client-avatar v-if="!loading" :dbid="client.dbid" :size="100"/>
                    </div>
                    <div class="card-body text-center px-5">
                        <h3>{{ client.nick }}</h3>
                        <div class="server-groups">
                            <server-groups v-if="!loading" :groups="client.serverGroups"/>
                        </div>
                        <p>{{ client.description }}</p>
                        
                        <div v-if="dbid != user.clientDbid && cfg.global.enabledPages.dashboard.friends">
                            <button v-if="!friendship" class="btn btn-primary" @click="addFriend"><i class="fa fa-plus"></i> Dodaj do znajomych</button>
                            
                            <div v-else-if="!friendship.accepted">
                                <div v-if="friendship.invoker_dbid == dbid" class="d-flex flex-row justify-content-around align-items-center">
                                    <button  class="btn btn-primary" @click="acceptFriend"><i class="fa fa-check"></i> Akceptuj zaproszenie</button>
                                    <button  class="btn btn-danger" @click="delFriend"><i class="fa fa-times"></i> Usuń zaproszenie</button>
                                </div>
                                
                                <button v-else class="btn btn-secondary"><i class="fa fa-sync"></i> Zaproszenie oczekuje na zatwierdzenie</button>
                            </div>
                            
                            <button v-else class="btn btn-danger" @click="delFriend"><i class="fa fa-times"></i> Usuń ze znajomych</button>
                        </div>
                    </div>
                    <div v-if="!loading && client.profileSettings.admin" class="ribbon ribbon-top-left func" id="ribbon"><span>{{ client.profileSettings.admin.name }}</span></div>
                </div>
            </div>

            <div class="col-xl-8">
                <div class="card client-info">
                    <div class="card-header text-center">
                        <i class="fa fa-info-circle"></i> Informacje
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-xl-6 profile-info d-flex justify-content-center">
                                <table class="w-100">
                                    <tr>
                                        <td>Identyfikator:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.uid }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>DBID:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.dbid }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Ostatnie połączenie:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.lastConnected | moment("DD-MM-YYYY HH:mm") }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Data pierwszego połączenia:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.created | moment("DD-MM-YYYY HH:mm") }}</span></td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-xl-6 profile-info d-flex justify-content-center">
                                <table class="w-100">
                                    <tr>
                                        <td>Platforma:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.platform }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Status:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.status }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Liczba punktów:</td>
                                        <td><span class="badge badge-soft-dark">{{ client.coins }}</span></td>
                                    </tr>
                                    <tr>
                                        <td>Ostatnie logowanie:</td>
                                        <td>
                                            <span class="badge badge-soft-dark" v-if="client.lastLogin">{{ client.lastLogin | moment("DD-MM-YYYY HH:mm") }}</span>
                                            <span class="badge badge-soft-dark" v-else>Nigdy</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-3">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-header text-center">
                        <i class="fa fa-chart-line"></i> Statystyki
                    </div>
                    <div class="card-body">
                        <b-tabs
                            pills
                            vertical
                            nav-class="p-0"
                            nav-wrapper-class="col-md-3 col-sm-12 col-12"
                            content-class="pt-0 px-2 text-muted"
                            v-if="!loading"
                        >
                            <b-tab v-for="(value, key, number) in tops"  :key="key" :title="value.name" :active="!number" title-item-class="mb-2">
                                <div class="row text-center py-3">
                                    <div class="col-md-12">
                                        <h3 class="top-main">{{ client.clientTops[key] ? getTopValue(key, client.clientTops[key].actual.value) : '---' }}</h3>
                                    </div>
                                </div>

                                <div class="row text-center">
                                    <div class="col-md-12 my-3">
                                        <div class="top-desc">Miejsce w rankingu</div>
                                        <div class="top-value"># {{ client.clientTops[key]? client.clientTops[key].actual.rank : '---' }}</div>
                                    </div>
                                </div>

                                <div class="row text-center">
                                    <div class="col-md-6 my-3">
                                        <div class="top-desc">Do pierwszego miejsca brakuje</div>
                                        <div class="top-value">{{ client.clientTops[key] ? getTopValue(key, client.clientTops[key].toFirst) : '---' }}</div>
                                    </div>
                                    <div class="col-md-6 my-3">
                                        <div class="top-desc">Do kolejnego miejsca brakuje</div>
                                        <div class="top-value">{{ client.clientTops[key] ? getTopValue(key, client.clientTops[key].toNext) : '---' }}</div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>

                <div class="card">
                    <div class="card-header text-center">
                        <i class="fa fa-comments"></i> Komentarze
                    </div>
                    <div class="card-body">
                        <comments v-if="!loading" :dbid="client.dbid"/>
                    </div>
                </div>
    
                <div class="card" v-if="showAdminOpinions && cfg.global.enabledPages.dashboard.adminOpinions">
                    <div class="card-header text-center">
                        <i class="fa fa-thumbs-up"></i> Opinie admina
                    </div>
                    <div class="card-body">
                        <admin-opinions v-if="!loading" :dbid="client.dbid"/>
                    </div>
                </div>
            </div>

            <div class="col-lg-4">
                <div class="card" v-if="!loading && getFriends().length && cfg.global.enabledPages.dashboard.friends">
                    <div class="card-header text-center">
                        <i class="fa fa-users"></i> Znajomi
                    </div>
                    <div class="card-body pt-4">
                        <carousel
                            :autoplay="true"
                            :perPage="friendsPerPage"
                            :paginationActiveColor="cfg.global.theme.primaryColor"
                        >
                            <slide v-for="friend in getFriends()" :key="friend.id" class="d-flex justify-content-center">
                                <div class="d-flex justify-content-center align-items-center flex-column">
                                    <client-avatar :dbid="friend.invoker_dbid == dbid ? friend.recipient.dbid : friend.invoker.dbid" :margin="false"/>
                                    <client :client="friend.invoker_dbid == dbid ? friend.recipient : friend.invoker"/>
                                </div>
                            </slide>
                        </carousel>
                    </div>
                </div>
                
                <div class="card" v-if="!loading && client.currentChannel && client.currentChannel.preview">
                    <div class="card-header text-center">
                        <i class="fab fa-teamspeak"></i> Z kim rozmawia
                    </div>
                    <div class="card-body">
                        <ul class="teamspeak-channels">
                            <channel :channel="client.currentChannel.preview" :clickable="false" real/>
                        </ul>
                        <small><i>Stan na: {{ client.currentChannel.generated | moment("DD-MM-YYYY HH:mm") }}</i></small>
                    </div>
                </div>

                <div class="card" v-if="!loading && client.privateChannel && client.privateChannel.preview">
                    <div class="card-header text-center">
                        <i class="fa fa-info-circle"></i> Kanał użytkownika
                    </div>
                    <div class="card-body">
                        <ul class="teamspeak-channels">
                            <channel :channel="client.privateChannel.preview" :clickable="false" real/>
                        </ul>
                        <small><i>Stan na: {{ client.privateChannel.generated | moment("DD-MM-YYYY HH:mm") }}</i></small>
                    </div>
                </div>
            </div>
        </div>

    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ClientAvatar from "../../../components/teamspeak/ClientAvatar";
import Comments from "./Comments";
import ProfileService from "@/services/profile.service";
import FriendsService from "@/services/friends.service";
const humanizeDuration = require("humanize-duration");
import AdminOpinions from "@/router/views/profile/AdminOpinions";
import {notificationMethods} from "@/state/helpers";
import { Carousel, Slide } from 'vue-carousel';

/**
 * Starter component
 */
export default {
    name: "Profil",
    components: {ClientAvatar, Layout, PageHeader, Comments, AdminOpinions, Carousel, Slide},
    data() {
        return {
            title: "Profil",
            items: [
                {
                    text: "Profil",
                    href: "/"
                },
                {
                    text: "Użytkownik",
                    active: true
                }
            ],
            loading: true,
            client: {},
            tops: {
                connections: {
                    name: 'Ilość połączeń',
                    notTime: true
                },
                connectedTimeSpent: {
                    name: 'Spedzony czas',
                    notTime: false
                },
                connectedTimeRecord: {
                    name: 'Najdłuższe połączenie',
                    notTime: false
                },
                /*levels: {
                    name: 'Poziomy',
                    notTime: true
                },*/
                idleTimeRecord: {
                    name: 'Czas AFK',
                    notTime: false
                },
                weekTimeSpent: {
                    name: 'TOP Tygodnia',
                    notTime: false
                },
            },
            showAdminOpinions: false,
            styleElem: null,
            friendship: null,
            friendsPerPage: 4
        };
    },
    watch: {
        $route() {
            this.loadData();
        }
    },
    computed: {
        user() {
            return this.$store.getters['auth/user'];
        },
        dbid() {
            return this.$route.params.dbid;
        },
        cfg() {
            return this.$store.getters['cfg/get'];
        },
    },
    mounted() {
        this.onResize();
        window.addEventListener("resize", this.onResize);
        this.loadData();
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        ...notificationMethods,
        onResize() {
            const width = document.body.clientWidth;

            if (width > 1700)
                this.friendsPerPage = 4;
            else if (width > 1200)
                this.friendsPerPage = 2;
            else if (width > 982)
                this.friendsPerPage = 1;
            else if (width < 400)
                this.friendsPerPage = 3;
            else
                this.friendsPerPage = 4;
        },
        loadData() {
            this.loading = true;
            this.showAdminOpinions = false;
            this.friendship = null;
            this.setAdminColor();

            ProfileService.getData(this.dbid).then(
                response => {
                    this.client = response.data;
                    this.setAdminColor();
                    this.setShowAdminOpinions();
                    this.setFriendship();
                    this.loading = false;
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        setFriendship() {
            if (Object.values(this.client.friends).length)
                Object.values(this.client.friends).forEach(friend => {
                    if (friend.invoker_dbid == this.user.clientDbid || friend.recipient_dbid == this.user.clientDbid)
                        this.friendship = friend;
                })
        },
        setShowAdminOpinions() {
            Object.values(this.cfg.panel.adminOpinions.adminGroups).forEach(adminGroup => {
                if (this.client.serverGroups.find(s => s.sgid == adminGroup))
                    this.showAdminOpinions = true;
            });
        },
        getTopValue(key, value) {
            if (!value)
                return '---';

            return this.tops[key].notTime ? value : humanizeDuration(value * 1000, { language: "pl", round: true, delimiter: " " });
        },
        getFriends() {
            return Object.values(this.client.friends).filter(f => f.accepted);
        },
        addFriend() {
            FriendsService.send(this.dbid).then(
                response => {
                    this.success("Pomyślnie wysłano zaproszenie do grona znajomych");
                    this.friendship = response.data.id;
                },
                error => {
                    console.log(error);
                }
            )
        },
        delFriend() {
            FriendsService.delete(this.friendship.id).then(
                () => {
                    this.success("Pomyślnie usunięto użytkownika z grona znajomych");
                    this.friendship = null;
                },
                error => {
                    console.log(error);
                }
            )
        },
        acceptFriend() {
            FriendsService.accept(this.friendship.id).then(
                () => {
                    this.success("Pomyślnie zaakceptowano zaproszenie do grona znajomych");
                    let fr = this.friendship;
                    this.friendship = null;
                    fr.accepted = true;
                    this.friendship = fr;
                },
                error => {
                    console.log(error);
                }
            )
        },
        setAdminColor() {
            if (!this.client.profileSettings || !this.client.profileSettings.admin || this.client.profileSettings.admin.color == "") {
                this.styleElem = null;
                document.getElementById('have-function').style.border = "0";
                return;
            }

            this.styleElem = document.body.appendChild(document.createElement("style"));

            this.styleElem.innerHTML = `
            .have-function { border: 2px solid ` + this.client.profileSettings.admin.color + `;}
            .ribbon.func span { background-color: ` + this.client.profileSettings.admin.color + `; }
            .ribbon.func::before,
            .ribbon.func::after { border: 5px solid ` + this.lighten(this.client.profileSettings.admin.color, -25) + `; }
            .ribbon.func span { color: ` + this.client.profileSettings.admin.textColor + `; }
            `;

            document.getElementById('have-function').style.border = "2px solid " + this.client.profileSettings.admin.color;
        },
        lighten(col, amt) {
            var usePound = false;
            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }
            var num = parseInt(col, 16);
            var r = (num >> 16) + amt;
            if (r > 255) {
                r = 255;
            } else if (r < 0) {
                r = 0;
            }
            var b = ((num >> 8) & 0x00FF) + amt;
            if (b > 255) {
                b = 255;
            } else if (b < 0) {
                b = 0;
            }
            var g = (num & 0x0000FF) + amt;
            if (g > 255) {
                g = 255;
            } else if (g < 0) {
                g = 0;
            }
            return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
        }
    }
};
</script>

<style lang="scss">
.client-main {
    min-height: 200px;

    @media only screen and (max-width: 560px) {
        &.with-social-media {
            margin-top: 10%;
        }
    }

    .server-groups {
    }

    .card-header {
        background-color: transparent;
        border: none;
        padding: 0;
        display: flex;
        justify-content: center;

        &.online .avatar {
            border: 2px solid green;
        }

        &.offline .avatar {
            border: 2px solid red;
        }

        &.away .avatar {
            border: 2px solid orange;
        }

        .avatar {
            width: 100px;
            height: 100px;
            border-radius: 50px;
            margin-top: -50px;
        }
    }

  &.with-ribbon {
    .card-header {
      @media only screen and (min-width: 1200px) and (max-width: 1600px), (max-width: 450px) {
        & {
          justify-content: flex-end;
        }
      }
    }
  }
}


/* common */
.ribbon {
    z-index: 99;
    width: 150px;
    height: 150px;
    overflow: hidden;
    position: absolute;
    display: none;
}

.have-function .ribbon {
    display: block;
}

.ribbon::before,
.ribbon::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
}

.ribbon span {
    position: absolute;
    display: block;
    width: 225px;
    padding: 15px 0;
    box-shadow: 0 5px 10px rgba(0, 0, 0, .1);
    color: #fff;
    font: 700 16px 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0, 0, 0, .2);
    text-transform: uppercase;
    text-align: center;
}

/* top left*/
.ribbon-top-left {
    top: -10px;
    left: -10px;
}

.ribbon-top-left::before,
.ribbon-top-left::after {
    border-top-color: transparent;
    border-left-color: transparent;
}

.ribbon-top-left::before {
    top: 0;
    right: 0;
}

.ribbon-top-left::after {
    bottom: 0;
    left: 0;
}

.ribbon-top-left span {
    right: -24px;
    top: 30px;
    transform: rotate(-45deg);
}

/* Top */
.top-value {
    font-weight: bold;
    font-size: 1rem;
    padding: 3px;
}

.top-main {
    font-size: 1.6rem;
    padding-bottom: 1.5rem;
}

/* Social media */
.social-media-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-right: 0!important;
    margin-left: 0!important;

    .social-media-line {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        width: auto;

        .social-media {
            margin-left: 5px;
            margin-right: 5px;
            font-size: 1.4rem;
        }
    }

    @media only screen and (max-width: 560px) {
        & {
            justify-content: center;

            .social-media {
                margin: 0 10px;
                font-size: 2rem;
            }
        }
    }
}

/* Profile info */
.profile-info tr td {
    padding: 10px 5px 10px 5px;
    border-bottom: 1px solid grey;
}

.profile-info tr td:nth-child(2) {
    padding-left: 20px;
}

/* Pagination */
.VueCarousel-pagination {
    margin-top: -30px;
}
</style>